import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';

export enum OfferOptionSnackBarType {
  PUBLISH,
  REMOVE_FROM_PORTAL,
}

export interface IOfferOptionSnackBarData {
  offerOption: OfferOption;
  optionType: string;
  isSuccess: boolean;
  type: OfferOptionSnackBarType;
}
